var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"houselist"},[_c('span',{staticStyle:{"font-size":"45px","color":"red"}},[_vm._v("这是楼盘列表")])])}]

export { render, staticRenderFns }